// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eKOb","index":"styles_index__1ioT8"};